/* @flow */

import * as React from 'react';
import { useCallback } from 'react';

import Localizer from '../../../helpers/localization';
import ButtonFX from '../../buttons/ButtonFX';
import { WidthKind } from '../../buttons/types';
import Modal from '../modal';
import './NewVersionModal.css';

export type NEW_VERSION_DATA_MODAL_TYPE = {
  currentVersion: string,
  newVersion: string,
};

const NewVersionModal = (): React.Node => {
  const handleOnClick = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Modal
      ariaLabel={Localizer.localize('accessibility.modal.new_version')}
      canCloseOnEscape={false}
      canCloseOnOverlayClick={false}
      className='newVersion'
      hasCloseButton={false}
      header={Localizer.localize('modal.new_version.title')}
      isAlert
    >
      <div className='newVersionContent'>
        <div>{Localizer.localize('modal.new_version.click_below')}</div>
        <ButtonFX autoFocus onClick={handleOnClick} widthKind={WidthKind.Stretched}>
          {Localizer.localize('modal.new_version.refresh')}
        </ButtonFX>
      </div>
    </Modal>
  );
};

export default NewVersionModal;
